import AxiosConfig, { RequestConfig } from 'config/api/AxiosConfig';
import { PaginationInfo } from 'types';
import { ORGANIZATIONS_URL } from './enpoints';
import {
  ImportedOrganizationFilters,
  ApproveImportedOrganizationValues,
  RejectImportedOrganizationValues,
} from '../types/importedOrganization';

const getImportedOrganizations = (
  pageInfo: PaginationInfo,
  filters?: ImportedOrganizationFilters,
  sorting?: string[]
) => {
  const params = {
    pageIndex: pageInfo.pageIndex,
    pageSize: pageInfo.pageSize,
    ...(filters && {
      ...(filters.search && { search: filters.search }),
      ...(filters.status && { statuses: filters.status }),
    }),
    ...(sorting && { orderBys: sorting }),
  };

  const requestConfig: RequestConfig = {
    params,
    url: `${ORGANIZATIONS_URL}/imported`,
  };

  return AxiosConfig.fetchAxiosGetRequest(requestConfig);
};

const approveImportedOrganization = (approveOrganizationValues: ApproveImportedOrganizationValues) => {
  const requestConfig: RequestConfig = {
    url: `${ORGANIZATIONS_URL}/${approveOrganizationValues.id}:approveimport`,
  };

  return AxiosConfig.fetchAxiosPostRequest(requestConfig);
};

const rejectImportedOrganization = (rejectOrganizationValues: RejectImportedOrganizationValues) => {
  const requestConfig: RequestConfig = {
    url: `${ORGANIZATIONS_URL}/${rejectOrganizationValues.id}:rejectimport`,
  };

  return AxiosConfig.fetchAxiosPostRequest(requestConfig);
};

export default { getImportedOrganizations, approveImportedOrganization, rejectImportedOrganization };
